import ReactDOM from "react-dom";
import { PageHeader } from "./Header";
import PageContent from "./PageContent";
import styles from "./rightPanel.module.css";

const RightPanel = ({ header, articles, items }) => {
  return ReactDOM.createPortal(
    <div className={styles.rightPanel}>
      {header ? <PageHeader {...header} /> : null}
      <div
        style={{
          overflow: "hidden",
          height: "calc(100% - 300px)",
          display: "flex",
          flexDirection: "column",
          flexShrink: "1",
          flexGrow: "1",
        }}
      >
        <PageContent articles={articles} items={items} />
      </div>
    </div>,
    document.getElementById("rightPanel")
  );
};

export default RightPanel;
